module.exports = __webpack_public_path__ + "static/media/settings.936a2a0d.svg";